import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useLocation, } from "react-router-dom";
import { useForm } from "react-hook-form";

import Breadcrumb, {BreadcrumbItem} from '../../components/Breadcrumb';
import { BlankLink } from '../../components/CustomLink';


type ContactValues = {
  inquiry: string,    // お問合せ内容
  mail: string,       // メールアドレス
  name: string,       // 氏名
  confirm: boolean    // プライバシーポリシーの同意
}
const Contact = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // デフォルト値
    const defaultValues = {
        inquiry: (location.state?.contactValues)?location.state.contactValues.inquiry:'',
        mail: (location.state?.contactValues)?location.state.contactValues.mail:'',
        name: (location.state?.contactValues)?location.state.contactValues.name:'',
    }

    // フォームのバリデーション
    const { register, handleSubmit, getValues, watch, formState: { errors },} = useForm<ContactValues>();
    const formValidate = {
      'inquiry': {
        required: { value: true, message: 'お問合せ内容は必須項目です。'},
        //maxLength: { value: 2000, message: '2000文字以内で入力してください。'},
        validate: (value:string) => {
            value = value.trim();
            if (value.length <= 0) {
                return 'お問合せ内容は必須項目です。';
            }
        }
      },
      'mail': {
        required: { value: true, message: 'メールアドレスは必須項目です。'},
        maxLength: { value: 254, message: '255文字以内で入力してください。'},
        pattern: { value: /\S+@\S+\.\S+/, message: 'メールアドレスの形式で入力してください。'}, // ココでは簡易
        validate: (value:string) => {
            value = value.trim();
            if (value.length <= 0) {
                return 'メールアドレスは必須項目です。';
            }
            // アカウント、ドメインに分解してチェック
            const [account, domain] = value.split('@');
            if (/^[a-zA-Z0-9_\-\+]+(\.[a-zA-Z0-9_\-]+)*$/.test(account) === false) { // アカウント形式チェック
                return 'メールアドレスの形式で入力してください。';
            }
            if (account.length > 64) { // アカウント文字数のチェック
                return 'メールアドレスの形式で入力してください。';
            }
            if (/^([a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]\.)+[a-zA-Z]{2,}$/.test(domain) === false) { // ドメイン形式チェック
                return 'メールアドレスの形式で入力してください。';
            }
        }
      },
      'name': {
        maxLength: { value: 20, message: '20文字以内で入力してください。'},
        validate: (value:string) => {
            const preStr = value;
            const trimStr = value.trim();
            if (trimStr.length <= 0 && preStr != trimStr) {
                return '空白文字のみの入力はできません。';
            }
        }
      },
      'confirm': {
        //required: { value: true, message: 'プライバシーポリシーに同意するにチェックを入れてください。'},
      }
    }
  
    // 「内容を確認する」ボタンの制御
    const [ send, setSend ] = React.useState<boolean>(false);
    const watchConfirm = watch('confirm', false);// プライバシーポリシーの同意のチェック監視
    useEffect(() => {
        setSend(watchConfirm);
    }, [watchConfirm])

    //「内容を確認する」ボタンイベントハンドラ
    const handleConfirm = (formData:ContactValues) => {
        navigate('/confirm', { state: {contactValues: formData}});
    }

    // パンくずリストリンク
    const breadcrumbItems:BreadcrumbItem[] = [
        {'label': 'ホーム', 'path': '/'},
        {'label': 'お問合せ', 'path':'/contact/index.html'}
    ]

    //
    return (
        <>
        <Helmet>
            <title>お問合せ | 予算書・決算書データベース</title>
        </Helmet>
        <main id="main" className="l-contents-main">
        <div className="l-contents l-contents--head">
            <div className="l-contents__inner">

            <Breadcrumb itemLists = {breadcrumbItems} />

            <div className="c-blk-head">
                <h1 className="c-heading-lv1">お問合せ</h1>
            </div>
            <div className="c-blk-txt c-blk-txt--lg">
                <p>予算書・決算書データベース（以下「当サイト」という。）のよりよい運営を行っていくために、当サイトに関する操作方法のご質問やご意見を受け付けております。<br/>
                ご質問については原則として入力いただいたメールアドレスに回答させていただきますが、回答に時間を要する場合や、内容によって回答できかねる場合がありますのでご了承ください。</p>
            </div>
            <div className="c-blk-txt">
                <p>なお、当サイトの運営以外の財務省に対するご意見などは、「<BlankLink  href="https://www.mof.go.jp/application-contact/feedback/index.html">財務省のご意見箱</BlankLink>（財務省ホームページ）」からお願いいたします。</p>
            </div>
            </div>
        </div>
        <div className="l-contents l-contents--body">
            <div className="l-contents__inner">
            <div className="c-panel">

              <form className="c-form c-contact-input" noValidate={true} onSubmit={handleSubmit(handleConfirm)}>
                
                <ol className="c-form-flow">
                    <li className="c-form-flow__step" aria-current="step">
                    <span className="c-form-flow__step-mark">1</span>
                    <span className="c-form-flow__step-text">内容の入力</span>
                    </li>
                    <li className="c-form-flow__step">
                    <span className="c-form-flow__step-mark">2</span>
                    <span className="c-form-flow__step-text">確認</span>
                    </li>
                    <li className="c-form-flow__step">
                    <span className="c-form-flow__step-mark">3</span>
                    <span className="c-form-flow__step-text">完了</span>
                    </li>
                </ol>
        
                    <dl className="c-form-list">
                    <div className="c-form-item">
                    <dt className="c-form-item__term">
                        <label htmlFor="inquiry" className="c-form-item__label">お問合せ内容</label><span className="c-form-item__required">必須</span>
                    </dt>
                    <dd className="c-form-item__support">2000文字以内</dd>
                    <dd className="c-form-item__detail">
                        <textarea id="inquiry" className="c-input-textarea" rows={8} maxLength={2000} {...register("inquiry", formValidate["inquiry"])} aria-required="true" aria-describedby={(errors.inquiry)?"inquiryError":undefined} aria-invalid={(errors.inquiry)?"true":"false"}>{defaultValues.inquiry}</textarea>
                        {errors.inquiry &&
                        <p id="inquiryError" className="c-text--error c-flex c-flex--between u-mt-sm" aria-live="polite">
                        <span>{errors.inquiry.message}</span>
                        {(getValues('inquiry').length > 2000) && <span className="c-flex__fix">{getValues('inquiry').length} / 2000</span>}
                        </p>
                        }
                    </dd>
                    </div>
                    <div className="c-form-item">
                    <dt className="c-form-item__term">
                        <label htmlFor="mail" className="c-form-item__label">メールアドレス</label><span className="c-form-item__required">必須</span>
                    </dt>
                    <dd className="c-form-item__detail">
                        <div className="c-form-input">
                        <input type="email" id="mail" placeholder="" className="c-input-text" defaultValue={defaultValues.mail} {...register("mail", formValidate["mail"])} aria-required="true" aria-describedby={(errors.mail)?"emailError":undefined} aria-invalid={(errors.mail)?"true":"false"}/>
                        {errors.mail &&
                        <p id="emailError" className="c-text--error u-mt-sm" aria-live="polite">{errors.mail.message}</p>
                        }
                        </div>
                    </dd>
                    </div>
                    <div className="c-form-item">
                    <dt className="c-form-item__term">
                        <label htmlFor="name" className="c-form-item__label">氏名</label>
                    </dt>
                    <dd className="c-form-item__support">20文字以内</dd>
                    <dd className="c-form-item__detail">
                        <div className="c-form-input">
                        <input type="text" id="name" placeholder="" className="c-input-text" maxLength={20} defaultValue={defaultValues.name} {...register("name", formValidate["name"])} aria-describedby={(errors.name)?"nameError":undefined} aria-invalid={(errors.name)?"true":"false"}/>
                        {errors.name &&
                        <p id="nameError" className="c-text--error u-mt-sm" aria-live="polite">{errors.name.message}</p>
                        }
                        </div>
                    </dd>

                    </div>
                </dl>
                <div className="c-text-block c-form__agreement">
                    <p><BlankLink href="/privacy/index.html">プライバシーポリシー</BlankLink>をご確認の上、同意するにチェックしてください。</p>
                    <div className="c-check-wrap u-mt-sm">
                    <input type="checkbox" id="confirm" value="true" {...register("confirm", formValidate["confirm"])} required={true} aria-required="true" />
                    <label htmlFor="confirm">プライバシーポリシーに同意する</label><span className="c-form-item__required">必須</span>
                    </div>
                </div>
                <div className="c-form__submit">
                    <button type="submit" className="c-button c-button--lg" aria-disabled={!send}>内容を確認する</button>
                </div>
                </form>
            </div>
            </div>
        </div>
        </main>
        </>
    )
};

export default Contact;